<template lang="pug">
AppModal(
  ref="modal"
  :value="showModal"
  title="Ejecutar Webhook de Cambio de Estado Masivo"
  size="lg"
  hide-footer
  @hidden="onHidden"
)
  b-form-group(label="IDs de Envíos" description="Pega los IDs separados por coma, espacio o salto de línea")
    b-form-textarea(
      v-model="rawIds"
      rows="5"
      placeholder="Ej: 123, 456, 789"
    )

    .mb-3(v-if="parsedIds.length")
      .input-title.mb-2 {{ parsedIds.length }} ID{{ parsedIds.length !== 1 ? 's' : '' }} detectado{{ parsedIds.length !== 1 ? 's' : '' }}
      b-row
        b-col.mb-1(
          v-for="id in parsedIds"
          :key="id"
          cols="auto"
        )
          b-badge.mr-1(variant="primary" pill)
            | {{ id }}
            b-button-close.ml-1(@click.stop="removeId(id)")

    b-alert(
      v-if="result"
      :variant="result.notFound.length ? 'warning' : 'success'"
      show
      dismissible
    )
      p.mb-1 Total enviados: {{ result.total }}
      p.mb-1 Procesados: {{ result.processed }}
      p.mb-0(v-if="result.notFound.length") No encontrados: {{ result.notFound.join(', ') }}

    b-alert(v-if="errorDetail" variant="danger" show dismissible) {{ errorDetail }}

  template(#modal-footer)
    b-button(variant="outline-secondary" @click="clearAll") Limpiar
    AppButton(
      variant="primary"
      :loading="loading"
      :disabled="!parsedIds.length"
      @click="onExecute"
    ) Ejecutar Webhook
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '../UI/AppModal.vue'
import AppButton from '../UI/AppButton.vue'

export default {
  name: 'BulkExecuteWebhookChangeStateModal',
  components: {
    AppModal,
    AppButton
  },
  data () {
    return {
      showModal: false,
      rawIds: '',
      loading: false,
      result: null,
      errorDetail: null
    }
  },
  computed: {
    parsedIds () {
      if (!this.rawIds.trim()) return []
      const ids = this.rawIds
        .split(/[\s,]+/)
        .map(s => s.trim())
        .filter(s => s.length > 0)
        .map(s => parseInt(s, 10))
        .filter(n => !isNaN(n))
      return [...new Set(ids)]
    }
  },
  methods: {
    ...mapActions(['bulkExecuteWebhookChangeState']),
    show (ids = []) {
      this.rawIds = ids.join(', ')
      this.result = null
      this.errorDetail = null
      this.showModal = true
    },
    removeId (id) {
      const ids = this.parsedIds.filter(i => i !== id)
      this.rawIds = ids.join(', ')
      this.result = null
      this.errorDetail = null
    },
    clearAll () {
      this.rawIds = ''
      this.result = null
      this.errorDetail = null
    },
    onHidden () {
      this.rawIds = ''
      this.result = null
      this.errorDetail = null
      this.showModal = false
    },
    async onExecute () {
      if (!this.parsedIds.length) return

      this.loading = true
      this.result = null
      this.errorDetail = null

      try {
        const response = await this.bulkExecuteWebhookChangeState({
          ids: this.parsedIds
        })

        if (response.status >= 200 && response.status < 300) {
          this.result = response.data
          this.$emit('executed', response.data)
          this.$root.$bvToast.toast('Webhook ejecutado correctamente', {
            title: 'Éxito',
            variant: 'success'
          })
        } else {
          this.errorDetail = response.data?.message || 'Error al ejecutar el webhook'
        }
      } catch (error) {
        this.errorDetail = error?.response?.data?.detail || error?.response?.data?.message || error?.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.badge {
  font-size: 0.875rem;
  padding: 0.4em 0.6em;

  .b-button-close {
    font-size: 0.65rem;
  }
}
</style>
